import { services } from './business';

export type CmsImageFormat = { url: string; width?: number; height?: number };
export type CmsMedia = CmsImageFormat & { alternativeText?: string; caption?: string; name?: string; formats?: { large?: CmsImageFormat; medium?: CmsImageFormat; small?: CmsImageFormat } };
export type CmsService = {
  id: string | number; service_name?: string; title?: string; caption?: string;
  description?: string; details_html?: string; image?: CmsMedia | null;
};
export type Service = typeof services[number] & { image?: CmsMedia | null; detailsHtml?: string; fromCms?: boolean };
export type OurService = { id: string | number; url?: string; datetime?: string; title?: string; description?: string; release_status?: 'available' | 'coming_soon'; image?: CmsMedia | null };
export type Work = { id: string | number; title?: string; image?: CmsMedia | null; contentHTML?: string; category?: string; updatedAt?: string; datePublished?: string };
export type Company = {
  name?: string; postcode?: string; address?: string; establishment_date?: string; business?: string;
  googlemap_iframe?: string; map_url?: string; address2?: string; postcode2?: string;
  googlemap_iframe2?: string; map_url2?: string;
};
export type Greeting = { name?: string; position?: string; image?: CmsMedia | null; description?: string; personal_history?: string };

// tech-support was consolidated into ai-dx. Retain other CMS services independently.
export function mergeServices(items: CmsService[]): Service[] {
  const records: Service[] = items.filter(item => item.service_name !== 'tech-support').map(item => {
    const slug = item.service_name || String(item.id);
    const supplement = services.find(service => service.slug === slug);
    return {
      slug, number: '', english: supplement?.english || ({ web: 'WEB ENGINEERING', app: 'MOBILE ENGINEERING', 'technical-training': 'TECHNICAL TRAINING' } as Record<string, string>)[slug] || 'ENGINEERING & SUPPORT',
      title: item.title || slug, summary: item.caption || '', description: item.description || '',
      image: item.image, detailsHtml: item.details_html || '', fromCms: true,
      tags: supplement?.tags || [], offerings: supplement?.offerings || [], flow: supplement?.flow || [],
    };
  });
  const additions = services.filter(service => service.slug !== 'network' && !records.some(record => record.slug === service.slug));
  const order = ['ai-agent', 'ai-dx', 'ai-development', 'web', 'app', 'network', 'technical-training'];
  const all = [...additions, ...records].sort((a, b) => (order.includes(a.slug) ? order.indexOf(a.slug) : 100) - (order.includes(b.slug) ? order.indexOf(b.slug) : 100));
  return all.map((service, i) => ({ ...service, number: String(i + 1).padStart(2, '0') }));
}

export function workTitle(work: Work) {
  return work.title?.trim() || work.image?.alternativeText?.trim() || `${work.category || '開発'}の実績`;
}

export function sortWorks(items: Work[]) {
  const timestamp = (item: Work) => Date.parse(item.updatedAt || item.datePublished || '') || 0;
  return [...items].sort((a, b) => timestamp(b) - timestamp(a));
}
